// frontend/src/components/Footer/Footer.js

import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="App-footer">
            <p>© NSBE UMBC Chapter</p>
        </footer>
    );
};

export default Footer;
